export default "__VITE_ASSET__CiauR3D7__"